import Vue from 'vue';

import SvgIcon from '@/components/common/images/SvgIcon';
import LoaderIcon from '@/components/common/LoaderIcon';

// Should be replaced with UI Kit icon
Vue.component('svg-icon', SvgIcon);
// Should be replaced with loader or skeleton
Vue.component('loader-icon', LoaderIcon);
